// Expose Chart.js globally
// so that following imports in application.js have access to `Chart`

import Chart from 'chart.js/auto';
import { Tooltip } from 'chart.js';

window.Chart = Chart;
Chart.Tooltip = Tooltip;
